
class CustomDropZone {

    constructor(wrapperSelector,custom_color = false) {
        this.wrapper = document.querySelector(wrapperSelector);
        this.custom_color = custom_color;
        if (!this.wrapper) return;

        this.dropZone = this.wrapper.querySelector(".dropZone");
        this.input = this.wrapper.querySelector(".dropZoneInput");
        this.uploadProgressBlock = this.wrapper.querySelector(".upProgressBlock");
        this.precentBlock = this.wrapper.querySelector(".precentBlock");
        this.progressBarLine = this.wrapper.querySelector(".progressBarLine");
        this.upKonfigurenWrapper = this.wrapper.querySelector(".upKonfigurenWrapper");
        this.upFinalZone = this.wrapper.querySelector(".finalZone");
        this.upFinalImageSquareMsgBlock = this.wrapper.querySelector(".upFinalImageSquareMsg");
        this.upFinalImage = this.wrapper.querySelector(".upFinalImage");
        this.upFormatedFileSize = this.wrapper.querySelector(".upFormatedFileSize");
        this.upErrorBlock = this.wrapper.querySelector(".upErrorBlock");
        this.upErrorMsg = this.wrapper.querySelector(".upErrorMsg");
        this.upKonfiguren = this.wrapper.querySelector(".up-konfiguren");
        this.maxFileSize = 200000000;
        const apiUrlDiv = document.getElementById("atc_api_url");
        this.apiUrl = apiUrlDiv ? apiUrlDiv.innerHTML.trim() : "https://atc.rueckwand24.com";
        this.uploadUrl = `${this.apiUrl}/vl/cart/custom_image`;

        this._init();
    }

    _init() {
        this.dropZone.addEventListener("click", () => this.input.click());

        this.dropZone.addEventListener("dragover", e => {
            e.preventDefault();
            this.dropZone.classList.add("hover");
        });

        this.dropZone.addEventListener("dragleave", e => {
            e.preventDefault();
            this.dropZone.classList.remove("hover");
        });

        this.dropZone.addEventListener("drop", e => {
            e.preventDefault();
            this.dropZone.classList.remove("hover");
            const file = e.dataTransfer.files[0];
            this._handleFile(file);
        });

        this.input.addEventListener("change", e => {
            const file = e.target.files[0];
            this._handleFile(file);
        });

        this.wrapper.querySelector(".upFinalDellButton").addEventListener("click", () => {
            this._cleanInput();
            this._deleteUploadedImage();
        });

        
        this.upKonfiguren.addEventListener("click", () => {
            if(this.custom_color) {
                const color_name = document.querySelector("#wf_color_name");
                    const product_id = document.querySelector("#wf_product_id");

                    if (color_name.value === "" || product_id.value === "") {
                    if (color_name.value === "") {
                        this._showError("Bitte benenne Deine Wunsch-Farbe konkret");
                    }
                    return;
                    }
                    localStorage.setItem("color_name",product_id.value+"|"+color_name.value );    
            }

            const mediaUrl = localStorage.getItem("shopify_media_url");
            if (mediaUrl) {
                this._makeRedirect();
            } else {
                this.input.click();
            }
        });
    }

    _handleFile(file) {
        if (!file) return;
        this.upFormatedFileSize.textContent = this._formatBytes(file.size);

        if (file.size > this.maxFileSize) {
            this._showError("The file is too big!");
            return;
        }

        const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
        if ([".jpg", ".jpeg", ".png"].includes(ext) && ["image/jpeg", "image/png"].includes(file.type)) {
            this._hideError();
            this._fakeUploadProgress(0, 80, 500, file);
            this._simulateUpload(file);
        } else {
            this._showError("Ungültiger Dateityp. Dateiendung jpg, jpeg, png!");
        }
    }

    _showError(msg) {
        this._stopFakeProgress();
        this.upErrorMsg.textContent = msg;
        this.upErrorBlock.classList.remove("hidden");
        this.dropZone.classList.remove("drop");
    }

    _hideError() {
        this.upErrorBlock.classList.add("hidden");
        this.upErrorMsg.textContent = "";
    }

    _cleanInput() {
        try {
            this.input.value = "";
            if (this.input.value) {
                this.input.type = "text";
                this.input.type = "file";
            }
        } catch (e) {
            console.error("Error cleaning input", e);
        }
    }

    _deleteUploadedImage() {
        this.progressBarLine.style.width = "";
        this.dropZone.classList.remove("drop");
        this.precentBlock.textContent = '0%'
        this.upFinalImage.src = "";
        this.upFinalZone.classList.add("hidden");
        this.upKonfigurenWrapper.classList.add("hidden");
        this.dropZone.classList.remove("hidden");
        if (this.timerId) clearInterval(this.timerId);
    }

    _fakeUploadProgress(percent = 1, maxPercent = 80, delay = 500, file) {
        this.uploadProgressBlock.classList.remove("hidden");
        let currentPercent = percent;

        this.timerId = setInterval(() => {
            if (currentPercent <= maxPercent) {
                this.precentBlock.textContent = currentPercent + "%";
                this.progressBarLine.style.width = currentPercent + "%";
                currentPercent++;
                if (currentPercent === 5) {
                    clearInterval(this.timerId);
                    this._previewUploadedImage(file);
                    this._fakeUploadProgress(currentPercent, maxPercent, 1000, file);
                }
            } else {
                clearInterval(this.timerId);
            }
        }, delay);
    }

    _stopFakeProgress() {
        this.uploadProgressBlock.classList.add("hidden");
        if (this.timerId) clearInterval(this.timerId);
    }

    _previewUploadedImage(file) {
        this.upFinalImage.src = URL.createObjectURL(file);
        this.upFinalImage.onload = () => {
            this.dropZone.classList.add("hidden");
            this.upFinalZone.classList.remove("hidden");
            // this.upKonfigurenWrapper.classList.remove("hidden");
            this.upFinalImageSquareMsgBlock.textContent = `${this.upFinalImage.naturalWidth} x ${this.upFinalImage.naturalHeight} px`;
        };
    }

    _makeRedirect() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const productTemplate = urlParams.get("view");

    const productUrlPart = this.wrapper.getAttribute("data-product-url");
    if (!productUrlPart) {
        location.reload();
    } else {
        const redirectUrl = window.location.origin + productUrlPart;
        window.location.href = redirectUrl;
    }
}


_simulateUpload(file) {
    const formData = new FormData();
    const uniqueFileName = this._generateUniqueFileName(file.name);
    formData.append("custom_image", file, uniqueFileName);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", this.uploadUrl, true);
    xhr.responseType = "json";

    // xhr.upload.onprogress = (event) => {
    //     if (event.lengthComputable) {
    //         const percent = Math.round((event.loaded / event.total) * 100);
    //         this.precentBlock.textContent = percent + "%";
    //         this.progressBarLine.style.width = percent + "%";
    //     }
    // };

    xhr.onload = () => {
        if (xhr.status === 200) {
            const response = xhr.response;
            // const shopifyUrl = response.shopify_media_url_580px || response.app_media_url;
            const shopifyUrl = response.app_media_url;
            this._previewUploadedImageFromUrl(shopifyUrl);
            localStorage.setItem("shopify_media_url", shopifyUrl);
            localStorage.setItem("app_media_url", response.app_media_url);
            this._fakeProgressFinal();
        } else {
        showUpError("Das Hochladen dieser Datei ist fehlgeschlagen. Bitte kontaktiere uns unter +49 611 978 690 33 oder kontakt@veroluma.com für eine schnelle Lösung.");
        }
    };

    xhr.onerror = () => {
        this._showError("Upload failed. Please try again.");
    };

    this.dropZone.classList.add("drop");
    xhr.send(formData);
}



        _previewUploadedImageFromUrl(imageUrl) {
            this.upFinalImage.src = imageUrl;
            this.upFinalImage.onload = () => {
                this.dropZone.classList.add("hidden");
                this.upFinalZone.classList.remove("hidden");

                this.upFinalImageSquareMsgBlock.textContent = `${this.upFinalImage.naturalWidth} x ${this.upFinalImage.naturalHeight} px`;
            };
        }


    _fakeProgressFinal() {
        let currentPercent = 95;
        this.timerFinalId = setInterval(() => {
            if (currentPercent <= 100) {
                this.precentBlock.textContent = currentPercent + "%";
                this.progressBarLine.style.width = currentPercent + "%";
                currentPercent++;
            } else {
                clearInterval(this.timerFinalId);
                this.uploadProgressBlock.classList.add("hidden");
                this.upKonfigurenWrapper.classList.remove("hidden");
                this.precentBlock.textContent = "0%";
                this.progressBarLine.style.width = "";
            }
        }, 100);
    }

    _formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
    }

    _generateUniqueFileName(originalName) {
    const fileExtension = originalName.substring(originalName.lastIndexOf(".")).toLowerCase();
    const random1 = Math.floor(Math.random() * 1_000_000_000);
    const random2 = Math.floor(Math.random() * 1_000_000_000);
    const timestamp = Date.now();
    return `${timestamp}_${random1}_${random2}${fileExtension}`;
    }

}

document.addEventListener("DOMContentLoaded", () => {
    new CustomDropZone("#dropZoneWrapper1");
    new CustomDropZone("#dropZoneWrapper2",true);
});

